import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function isAuthenticated(auth: ReturnType<typeof useAuth>) {
  return !!(auth.user || auth.collegeAdmin || auth.firmAdmin || auth.coach);
}

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  if (auth.loading) return <div className="loading">Loading...</div>;
  if (!isAuthenticated(auth)) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

// Super admin only. All other authenticated roles redirect to /dashboard.
export function SuperAdminRoute({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  if (auth.loading) return <div className="loading">Loading...</div>;
  if (!isAuthenticated(auth)) return <Navigate to="/login" replace />;
  if (!auth.user) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

// Firm admin (or dual-role user on firm path). Non-firm authenticated users go to /dashboard.
export function FirmAdminRoute({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  if (auth.loading) return <div className="loading">Loading...</div>;
  if (!isAuthenticated(auth)) return <Navigate to="/login" replace />;
  if (!auth.firmAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

// Coach (or dual-role user on coach path). Non-coach authenticated users go to /dashboard.
export function CoachRoute({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  if (auth.loading) return <div className="loading">Loading...</div>;
  if (!isAuthenticated(auth)) return <Navigate to="/login" replace />;
  if (!auth.coach) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
